import signedFetch from '../apiCalls/util/signedFetch';

export default (orgId, body) =>
  signedFetch('selfEnrol', `${__API_BASE__}/user/org/${orgId}/enrol-request`, 'POST', body);
